/* 更多接口*/
import { axios } from '@/utils/http'
import axios2 from 'axios'

export const getIntroduction = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
  baseURL: process.env.VUE_ENV === 'server' ? process.env.VUE_APP_BASE_URL : '/api'
}, '/competition/introduction')

// 获取父赛项列表
export const getParentCompetition = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
  hastoken: true
}, '/competition/getParentCompetition?' + params)

// 保存赛事信息
export const saveCompetition = (params) => {
  console.log('params', params)
  // Log organizersLogo for verification
  if (Array.isArray(params)) {
    params.forEach((item, index) => {
      console.log(`Form ${index} organizersLogo:`, item.organizersLogo)
    })
  }
  return axios({
    method: 'POST',
    contentType: 'jsonArray',
    data: params,
    noToast: true,
    hastoken: true
  }, '/competition/saveMultiLanguageCompetitions')
}

// 单文件上传
export const uploadFile = (formData) => {
  console.log('uploadFile: Sending request to /site/uploadCommon/upload')

  // Log form data entries
  if (formData && typeof formData.entries === 'function') {
    try {
      console.log('Form data entries:')
      for (const [key, value] of formData.entries()) {
        console.log(`- ${key}: ${value instanceof File
          ? `File[${value.name}, ${value.size} bytes, ${value.type}]`
          : value instanceof Blob
            ? `Blob[${value.size} bytes, ${value.type}]`
            : value}`)
      }
    } catch (e) {
      console.error('Error logging form data:', e)
    }
  }

  return axios({
    method: 'POST',
    contentType: 'formData',
    data: formData,
    noToast: true,
    hastoken: true
  }, '/site/uploadCommon/upload')
    .then(res => {
      console.log('uploadFile response:', res)
      return res
    })
    .catch(err => {
      console.error('uploadFile error:', err)
      throw err
    })
}

// 多文件上传
export const uploadMultiFile = (formData) => {
  return axios({
    method: 'POST',
    contentType: 'formData',
    data: formData,
    noToast: true,
    hastoken: true
  }, '/site/uploadCommon/multiUpload')
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = 'http'
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar
    } else {
      if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
        // return window._CONFIG['staticDomainURL'] + "/" + avatar;
        return 'http://39.155.148.158:9998/' + avatar
      }
    }
  } catch (err) {

  }
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrlTwo(avatar, subStr) {
  if (!subStr) subStr = 'http'
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar
    } else {
      if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
        return window._CONFIG['fileDomainURL'] + avatar
      }
    }
  } catch (err) {

  }
}

export const verifyTitle = (params) => {
  // 参数验证和清理
  if (!params || typeof params === 'string') {
    // 如果传入的是字符串（向后兼容），尝试解析
    const queryString = typeof params === 'string' ? params : ''
    return axios({
      method: 'GET',
      contentType: 'urlencoded',
      noToast: true,
      baseURL: process.env.VUE_ENV === 'server' ? process.env.VUE_APP_BASE_URL : '/api'
    }, '/competition/verifyTitle?' + queryString)
  }

  // 使用对象参数，更安全的参数传递
  const queryParams = new URLSearchParams()

  // 添加title参数，进行额外验证
  if (params.title && params.title.trim() &&
      params.title !== 'undefined' && params.title !== 'null') {
    queryParams.append('title', params.title.trim())
  } else {
    // 如果title无效，返回一个错误Promise
    return Promise.resolve({
      success: false,
      message: '标题不能为空'
    })
  }

  // 添加可选参数
  if (params.competitionId) {
    queryParams.append('competitionId', params.competitionId)
  }
  if (params.parentId) {
    queryParams.append('parentId', params.parentId)
  }

  return axios({
    method: 'GET',
    contentType: 'urlencoded',
    noToast: true,
    baseURL: process.env.VUE_ENV === 'server' ? process.env.VUE_APP_BASE_URL : '/api'
  }, '/competition/verifyTitle?' + queryParams.toString())
}
